import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CalendarIcon, TrendingUpIcon, ShieldCheckIcon, QuoteIcon, StarIcon } from 'lucide-react';
export function TestimonialSection() {
  const testimonials = [{
    name: 'Mariana G.',
    role: 'Profesora de Educación Física',
    quote: 'Material muy claro y bien organizado. Me ayudó a trabajar con más seguridad en clase. Lo uso todo el tiempo.'
  }, {
    name: 'Lucas R.',
    role: 'Entrenador Personal',
    quote: 'Lo que más valoro es lo visual. Las imágenes ayudan muchísimo a explicar mejor los ejercicios.'
  }, {
    name: 'Florencia M.',
    role: 'Profesora de Ed. Física',
    quote: 'Tenía información, pero desordenada. Este pack me dio claridad y tranquilidad para planificar sin dudar.'
  }, {
    name: 'Diego S.',
    role: 'Instructor de Musculación',
    quote: 'Se nota que está pensado para usar, no solo para leer. Ideal como material de consulta permanente.'
  }, {
    name: 'Javier L.',
    role: 'Profesor de Educación Física',
    quote: 'El contenido es muy bueno y claro. Me llevó un poco de tiempo recorrer todo el material, pero vale la pena como recurso de apoyo.'
  }, {
    name: 'Carla P.',
    role: 'Entrenadora Personal',
    quote: 'Me ayudó a tomar mejores decisiones y justificar lo que hago frente a mis alumnos.'
  }];
  return <section className="py-24 relative overflow-hidden bg-card/20" data-id="element-235">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-236">
        <FadeIn className="text-center mb-16" data-id="element-237">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-238">
            Lo que dicen los profesionales
          </h2>
          <p className="text-xl text-gray-400" data-id="element-239">
            Resultados reales de colegas que ya usan la Base Técnica.
          </p>
        </FadeIn>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-6 mb-24" data-id="element-240">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-241">
              <div className="bg-card border border-card-border rounded-2xl p-8 h-full flex flex-col relative overflow-hidden hover:border-primary/30 transition-colors" data-id="element-242">
                <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-primary/10" data-id="element-243" />

                <div className="flex gap-1 mb-4" data-id="element-244">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-secondary text-secondary" data-id="element-245" />)}
                </div>

                <p className="text-lg text-gray-300 italic mb-6 flex-1 relative z-10" data-id="element-246">
                  "{testimonial.quote}"
                </p>

                <div className="relative z-10" data-id="element-247">
                  <p className="font-bold text-white" data-id="element-248">{testimonial.name}</p>
                  <p className="text-primary text-sm font-medium" data-id="element-249">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* Mini Case */}
        <FadeIn data-id="element-250">
          <div className="bg-gradient-to-br from-primary/10 via-card to-background border border-primary/20 rounded-3xl p-8 md:p-16 shadow-2xl relative overflow-hidden max-w-4xl mx-auto" data-id="element-251">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full blur-3xl pointer-events-none" data-id="element-252" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-secondary/10 rounded-full blur-3xl pointer-events-none" data-id="element-253" />

            <div className="text-center mb-12 relative z-10" data-id="element-254">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 text-primary mb-6" data-id="element-255">
                <CalendarIcon className="w-8 h-8" data-id="element-256" />
              </div>
              <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-257">
                Lo que cambia en 7 días
              </h2>
              <p className="text-xl text-primary font-medium" data-id="element-258">
                Prueba de Credibilidad
              </p>
            </div>

            <div className="space-y-8 relative z-10" data-id="element-259">
              <div className="flex items-start gap-6 bg-background/50 p-6 rounded-2xl border border-card-border" data-id="element-260">
                <TrendingUpIcon className="w-8 h-8 text-green-500 shrink-0 mt-1" data-id="element-261" />
                <div data-id="element-262">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-263">
                    Estructura Inmediata
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-264">
                    En la primera semana de usar la Base Técnica, vas a notar
                    cómo tus clases ganan estructura.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-6 bg-background/50 p-6 rounded-2xl border border-card-border" data-id="element-265">
                <ShieldCheckIcon className="w-8 h-8 text-primary shrink-0 mt-1" data-id="element-266" />
                <div data-id="element-267">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-268">
                    Confianza Total
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-269">
                    Tus alumnos empiezan a confiar más en cada elección. Y vos
                    sentís la tranquilidad de tener una respuesta profesional
                    inmediata.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}